import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { DynamicPipelineAnalysisOutput } from 'libs/end-to-end/src/dynamic-pipeline-analysis';

export const PipelineAnalysisCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'pipelineAnalysis',
  isDataQueuingAllowed: true,
  outputFileName: 'pipeline_analysis_output.json',
  outputSchema: DynamicPipelineAnalysisOutput,
  resolveFocusArea: () => null,
  resolveFilters: (request) => {
    if (request.customVizId !== 'pipelineAnalysis') {
      throw new Error('Invalid custom viz ID');
    }
    return request.inputs.extras.filters;
  },
  resolveAnalysisName: (request) => {
    if (request.customVizId !== 'pipelineAnalysis') {
      throw new Error('Invalid custom viz ID');
    }
    return request.inputs.extras.analysisName;
  },
  checkEnoughDataStateEnabledGate: false,
  complexityParams: {
    aValue: 0.757,
    multiplier: 0.000509,
  },
  eventProperties: (request) => {
    if (request.customVizId !== 'pipelineAnalysis')
      throw new Error('Invalid custom viz ID');
    return {
      'Custom Viz Type': request.customVizId,
      Filters: request.inputs.extras.filters,
      'Selected Dimensions': [request.inputs.extras.dimension],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: (focusArea, request) => {
    if (request.customVizId !== 'pipelineAnalysis') {
      throw new Error('Invalid custom viz ID');
    }
    return `overview/${request.inputs.extras.analysisName}`;
  },
};
